// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__8CwI3","shimmer":"Skeleton_shimmer__UKJYp","text":"Skeleton_text__5o3_P"};